import { BaseModel } from '../../../../../../core/_base/crud';

	export class PhieuNhapKho extends BaseModel {

		static category_path = "NK";
		static DEFAULT_NUMBER_VALUE = "0,00";
		static optionsTinhTrang = [
			{
				id: 1,
				name: 'Đang soạn thảo',
				value: 'NK_PHIEUMOI',
			},
			{
				id: 2,
				name: 'Chờ xác nhận',
				value: 'NK_CHOXACNHAN',
			},
			{
				id: 3,
				name: 'Đã hủy',
				value: 'NK_DAHUY',
			},
			{
				id: 4,
				name: 'Hoàn tất',
				value: 'NK_HOANTAT',
			}
		];
		static optionsLoaiPhieu = [
			{
				id: 1,
				name : 'Nhập kho hàng NCC giao',
				value : 'Nhập kho hàng NCC giao',
			},
			{
				id : 2,
				name : 'Nhập kho hàng đề nghị',
				value : 'Nhập kho hàng đề nghị',
			},
			{
				id : 3,
				name : 'Nhập kho khác',
				value : 'Nhập kho khác',
			}
		];

		IdNk: number
		Sophieu: string
		Ngaynhapkho: string
		Ngaytao: string
		Nguoitao: number
		TenNguoitao: string
		Nguoisua: number
		Ngaysua: string
		Tinhtrang: string
		TenTinhTrang: string
		Ghichu: string
		Nguoixacnhan: number
		TenNguoixacnhan: string
		Ngayxacnhan: string
		Nguoigiaohangxn: number
		TenNguoigiaohangxn: string
		Ngaygiaohangxn: string
		LoaiPhieu: string
		LyDo: string
		DienGiai: string

		listNguoiThucHien: NguoiThucHienNhapKho[]
		listChiTietPhieuNhapKho: ChiTietPhieuNhapKho[]
		IsEnable_Duyet: boolean
		IsVisible_Duyet: boolean

		clear() {
			this.IdNk = 0;
			this.Sophieu = '';
			this.Ngaynhapkho = '';
			this.Ngaytao = '';
			this.Nguoitao = 0;
			this.TenNguoitao = '';
			this.Nguoisua = 0;
			this.Ngaysua = '';
			this.Tinhtrang = '';
			this.TenTinhTrang = '';
			this.Ghichu = '';
			this.Nguoixacnhan = 0;
			this.TenNguoixacnhan = '';
			this.Ngayxacnhan = '';
			this.Nguoigiaohangxn = 0;
			this.TenNguoigiaohangxn = '';
			this.Ngaygiaohangxn = '';
			this.LoaiPhieu = '';
			this.LyDo = '';
			this.DienGiai = '';
			this.listNguoiThucHien = [];
			this.listChiTietPhieuNhapKho = [];
			this.IsEnable_Duyet = false;
			this.IsVisible_Duyet = false;
		}
		copy(item: PhieuNhapKho) {
			this.IdNk = item.IdNk;
			this.Sophieu = item.Sophieu;
			this.Ngaynhapkho = item.Ngaynhapkho;
			this.Ngaytao = item.Ngaytao;
			this.Nguoitao = item.Nguoitao;
			this.TenNguoitao = item.TenNguoitao;
			this.Nguoisua = item.Nguoisua;
			this.Ngaysua = item.Ngaysua;
			this.Tinhtrang = item.Tinhtrang;
			this.TenTinhTrang = item.TenTinhTrang;
			this.Ghichu = item.Ghichu;
			this.Nguoixacnhan = item.Nguoixacnhan;
			this.TenNguoixacnhan = item.TenNguoixacnhan;
			this.Ngayxacnhan = item.Ngayxacnhan;
			this.Nguoigiaohangxn = item.Nguoigiaohangxn;
			this.TenNguoigiaohangxn = item.TenNguoigiaohangxn;
			this.Ngaygiaohangxn = item.Ngaygiaohangxn;
			this.LoaiPhieu = item.LoaiPhieu;
			this.LyDo = item.LyDo;
			this.DienGiai = item.DienGiai;
			this.listNguoiThucHien = item.listNguoiThucHien;
			this.listChiTietPhieuNhapKho = item.listChiTietPhieuNhapKho;
			this.IsEnable_Duyet = item.IsEnable_Duyet;
			this.IsVisible_Duyet = item.IsVisible_Duyet;
		}
	}

	export class ChiTietPhieuNhapKho extends BaseModel {
		IdCtnk: number
		IdNk: number
		IdHh: number
		TenHH: string
		MaHH: string
		DungSai: number
		QuyCach: string
		Dvt: number
		TenDVT: string
		IdCtdn: number
		IdNcc: number
		TenNCC: string
		MaNCC: string
		IdKho: number
		TenKho: string
		MaKho: string
		Phieukiemtracl: string
		Tinhtrang: boolean
		Solo: string
		Soluongdn: string
		Soluongthucnhap: string
		Handung: string
		HanSuDung: string
		Ghichulohang: string
		IdTs: number
		Sopo: string
		ViTriKho: string
		NguoiXacNhan: number
		TenNguoixacnhan: string
		Ngayxacnhan: string
		Ngaynhapkho: string
		Sophieu: string
		Quyetdinhlohang: number
		IdLo: number
		SoMay: string
		NgaySanXat: string
		isError: boolean
		messageError: string
		//Lưu thông tin phiếu hàng về
		SoPhieuDN: string
		Soluongchungtu: string
		LyDoChoPhepXuat: string

		SoLuongThucNhap: string
		SoLuongPhuHop: string
		SoLuongKhongPhuHop: string

		clear() {
			this.IdCtnk = 0;
			this.IdNk = 0;
			this.IdHh = 0;
			this.TenHH = '';
			this.MaHH = '';
			this.DungSai = 0;
			this.QuyCach = '';
			this.Dvt = 0;
			this.TenDVT = '';
			this.IdCtdn = 0;
			this.IdNcc = 0;
			this.TenNCC = '';
			this.MaNCC = '';
			this.IdKho = 0;
			this.TenKho = '';
			this.MaKho = '';
			this.Phieukiemtracl = '';
			this.Tinhtrang = true;
			this.Solo = '';
			this.Soluongdn = '0.00';
			this.Soluongthucnhap = '0.00';
			this.Handung = '';
			this.HanSuDung = '';
			this.Ghichulohang = '';
			this.IdTs = 0;
			this.Sopo = '';
			this.ViTriKho = '';
			this.NguoiXacNhan = 0;
			this.TenNguoixacnhan = '';
			this.Ngayxacnhan = '';
			this.Ngaynhapkho = '';
			this.Sophieu = '';
			this.Quyetdinhlohang = -1;
			this.IdLo = 0;
			this.isError = false;
			this.messageError = '';
			this.SoPhieuDN = '';
			this.Soluongchungtu = '';
			this.SoMay = '';
			this.NgaySanXat = '';
			this.LyDoChoPhepXuat = '';
			this.SoLuongThucNhap = '0.00';
			this.SoLuongPhuHop = '';
			this.SoLuongKhongPhuHop = '';
		}
		copy(item: ChiTietPhieuNhapKho) {
			this.IdCtnk = item.IdCtnk;
			this.IdNk = item.IdNk;
			this.IdHh = item.IdHh;
			this.TenHH = item.TenHH;
			this.MaHH = item.MaHH;
			this.DungSai = item.DungSai;
			this.QuyCach = item.QuyCach;
			this.Dvt = item.Dvt;
			this.TenDVT = item.TenDVT;
			this.IdCtdn = item.IdCtdn;
			this.IdNcc = item.IdNcc;
			this.TenNCC = item.TenNCC;
			this.MaNCC = item.MaNCC;
			this.IdKho = item.IdKho;
			this.TenKho = item.TenKho;
			this.MaKho = item.MaKho;
			this.Phieukiemtracl = item.Phieukiemtracl;
			this.Tinhtrang = item.Tinhtrang;
			this.Solo = item.Solo;
			this.Soluongdn = item.Soluongdn;
			this.Soluongthucnhap = item.Soluongthucnhap;
			this.Handung = item.Handung;
			this.HanSuDung = item.HanSuDung;
			this.Ghichulohang = item.Ghichulohang;
			this.IdTs = item.IdTs;
			this.Sopo = item.Sopo;
			this.ViTriKho = item.ViTriKho;
			this.NguoiXacNhan = item.NguoiXacNhan;
			this.TenNguoixacnhan = item.TenNguoixacnhan;
			this.Ngayxacnhan = item.Ngayxacnhan;
			this.Ngaynhapkho = item.Ngaynhapkho;
			this.Sophieu = item.Sophieu;
			this.Quyetdinhlohang = item.Quyetdinhlohang;
			this.IdLo = item.IdLo;
			this.isError = item.isError;
			this.messageError = item.messageError;
			this.SoPhieuDN = item.SoPhieuDN;
			this.Soluongchungtu = item.Soluongchungtu;
			this.SoMay = item.SoMay;
			this.NgaySanXat = item.NgaySanXat;
			this.LyDoChoPhepXuat = item.LyDoChoPhepXuat;
			this.SoLuongThucNhap = item.SoLuongThucNhap; 
			this.SoLuongPhuHop = item.SoLuongPhuHop; 
			this.SoLuongKhongPhuHop = item.SoLuongKhongPhuHop;
		}
	}

	export class NguoiThucHienNhapKho extends BaseModel {
		IdNk: number
		NguoiThucHien: number
		TenNguoiThucHien: string

		clear() {
			this.IdNk = 0;
			this.NguoiThucHien = 0;
			this.TenNguoiThucHien = '';
		}

		copy(item: NguoiThucHienNhapKho) {
			this.IdNk = item.IdNk;
			this.NguoiThucHien = item.NguoiThucHien;
			this.TenNguoiThucHien = item.TenNguoiThucHien;
		}
	}
